import axios from 'axios';

axios.defaults.timeout = '60000';
// axios.defaults.withCredentials = true; //解决用户失效的问题，千万勿删

// axios.defaults.baseURL = '/api/'
// axios.defaults.baseURL = 'http://huanbao1.luopan88.com/huanbao/api';
// axios.defaults.baseURL = 'http://218.4.111.162:6060/huanbao/api/';  // 测试服务器
// axios.defaults.baseURL = 'http://218.4.111.162:6060/hb-system/api/';
// axios.defaults.baseURL = 'http://10.0.1.3:6059/hb-system/api/'
// axios.defaults.baseURL = 'http://10.0.10.14:8090/huanbao/'    // 本地服务器
 axios.defaults.baseURL = 'http://221.224.13.15:8000/huanbao/api/'    // 正式服务器

// http request 拦截器
axios.interceptors.request.use(
        config => {
            // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
            config.data = JSON.stringify(config.data);
            config.headers = {
                'Content-Type': 'application/json'
            };
            // if(token){
            //   config.params = {'token':token}
            // }
            return config;
        },
        error => {
            return Promise.reject(error);
        }

    )
    // http response 拦截器
axios.interceptors.response.use(
    response => {
        // if (response.data.status == 500) {
        //     console.log(response.data);
        // }
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                console.log(err)
                reject(err);
            });
    });
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                // if(response.res != '1'){
                //     this.$toast.fail(response.msg);
                // }
                // else{
                resolve(response.data);
                // }
            }, err => {
                reject(err);
            });
    });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            });
    });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            });
    });
}